<script lang='typescript'>
const content: string = 'index'
</script>

<p>
  {content}
</p>
